// Copyright (c) 2015, LucrumERP Pvt. Ltd. and Contributors
// MIT License. See license.txt

// for translation
ducky._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = ducky._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = ducky._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = ducky._;

ducky.get_languages = function () {
	if (!ducky.languages) {
		ducky.languages = [];
		$.each(ducky.boot.lang_dict, function (lang, value) {
			ducky.languages.push({ label: lang, value: value });
		});
		ducky.languages = ducky.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return ducky.languages;
};
